import { gql } from "@apollo/client";
import { owner } from './partials';

export const QUERY_PROJECT_DETAILS = gql`
	query projectDetails($id: ID!) {
		project(id: $id) {
			__typename
			id
			id_form
			subtitle
			slug
			active
			title
			finalization
			constructionState{
				name
			}
			isEspecial
			features {
				img
				text
			}
			backup_img
			backup_title
			description
			rooms
			bedrooms
			bathrooms
			minM2
			facilities
			images {
				id
				image
				tag
			}
			tour3d
			image_count
			architect
			percentage_sold
			percentage_finished
			ocupation
			video
			builder
			address
			commercial_units {
				id
				code
				link
				title
				bedrooms
				bathrooms
				rooms
				m2
				m2Terrace
				price {
					amount
					currency {
						name
					}
				}
				property_type {
					id
					name
				}
			}
			${owner}
		}
	}
`;
